export function useAlert(
  title: string,
  description: string,
  cancelLabel: string,
  confirmLabel: string
) {
  return (onCancel: () => void, onConfirm: () => void) =>
    window.confirm(`${title} ${description}`) ? onConfirm() : onCancel();
}
